import PropTypes from 'prop-types'
import React from 'react'
import { bindActionCreators } from 'redux'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import ResponsiveImage from 'components/images/responsive-image'
import ShopTheLookItem from 'components/shared/shop-the-look/item'
import wishlistDuck from 'components/wishlist/duck'
import { segmentTrackProductListViewed } from 'lib/segment'
import env from 'config/env'
import Icon from 'components/common/icon'
import ICONS, { ICON_SIZE } from 'components/common/icon/const'
import Typo from 'constants/typography'
import SnackBar from 'components/common/snack-bar'
import { hasLocizeTranslation } from 'lib/utils/locize'
import styles from './styles.scss'

class ShopTheLookBase extends React.PureComponent {
  state = {
    snackBarMsg: undefined,
  }

  componentDidMount() {
    const { getWishlist, user, data } = this.props

    if (user) {
      getWishlist({})
    }

    if (data) {
      const { refType, refId, products, id_category } = data
      segmentTrackProductListViewed(
        {
          id_site_category: id_category,
          page_number: 1,
          product_list_ids: products.map((product) => product.id_product),
          site_category_name: '',
        },
        { ref_type: refType, ref_id: refId },
      )
    }
  }

  componentWillUnmount() {
    const { data } = this.props

    if (data?.onClose) {
      data.onClose()
    }
  }

  clearSnackBar = (e) => {
    if (e?.preventDefault) {
      e.preventDefault()
    }

    this.setState({ snackBarMsg: undefined })
  }

  setSnackBar = (res) => {
    const { t } = this.props

    this.setState({ snackBarMsg: undefined }, () => {
      this.setState({
        snackBarMsg:
          typeof res === 'string'
            ? res
            : hasLocizeTranslation(
                t,
                'CART_ITEM_ADD_SUCCESS',
                'Item has successfully added to the bag.',
              ),
      })
    })
  }

  renderProduct = (product, idx) => {
    const {
      data: { refId, refType },
    } = this.props

    return (
      <ShopTheLookItem
        key={product.id_product || product.product_id}
        product={product}
        idx={idx + 1}
        refType={refType}
        refId={refId}
        setSnackBar={this.setSnackBar}
      />
    )
  }

  renderSnackBar() {
    const { snackBarMsg } = this.state

    return (
      <SnackBar
        className="snack-bar"
        open={!!snackBarMsg}
        onClose={this.clearSnackBar}
        duration={5000}
        action={
          <Icon
            src={ICONS.close}
            size={ICON_SIZE.medium}
            onClick={this.clearSnackBar}
          />
        }
      >
        <span className={Typo.caption}>{snackBarMsg}</span>
      </SnackBar>
    )
  }

  render() {
    const { close, data, isPhone, t } = this.props

    if (!data) {
      return null
    }

    const { image, isLandscape } = data
    const fullImagePath = `${env.IMG_HOST}img/lookbooks/${image}.jpg`

    return (
      <div className="shop-the-look__container">
        <style jsx>{styles}</style>
        <div className="shop-the-look__header">
          <button
            className="shop-the-look__close"
            type="button"
            onClick={close}
          >
            <Icon src={ICONS.close} size={ICON_SIZE.medium} />
          </button>
          <span
            className={`${
              isPhone ? Typo.subtitle1 : Typo.h4
            } shop-the-look__title`}
          >
            {t('Shop The Look')}
          </span>
        </div>
        <div
          className={`shop-the-look__content ${
            isLandscape && !isPhone ? 'landscape' : ''
          }`}
        >
          {!isPhone && (
            <ResponsiveImage
              className={`shop-the-look__poster ${
                isLandscape ? 'landscape' : ''
              }`}
              imgRatio={isLandscape ? 0.667 : 1.5}
              src={fullImagePath}
            />
          )}
          <div
            className={`shop-the-look__products ${
              isLandscape && !isPhone ? 'landscape' : ''
            }`}
          >
            {data?.products.map(this.renderProduct)}
          </div>
        </div>
        {this.renderSnackBar()}
      </div>
    )
  }
}

ShopTheLookBase.defaultProps = {
  data: undefined,
  user: undefined,
}

ShopTheLookBase.propTypes = {
  close: PropTypes.func.isRequired,
  data: PropTypes.shape({
    image: PropTypes.string,
    isLandscape: PropTypes.bool,
    onClose: PropTypes.func,
    products: PropTypes.arrayOf(PropTypes.shape({})),
    refId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    refType: PropTypes.string,
    id_category: PropTypes.number,
  }),
  isPhone: PropTypes.bool.isRequired,
  getWishlist: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  user: PropTypes.shape({}),
}

const Extended = translate('global')(ShopTheLookBase)

const ShopTheLook = connect(
  (state) => ({
    isPhone: state.device.isPhone,
    user: state.auth.user,
  }),
  (dispatch) =>
    bindActionCreators({ getWishlist: wishlistDuck.creators.get }, dispatch),
)(Extended)

export default ShopTheLook
